import React, { Component } from "react";
import PrismicReact from "prismic-reactjs";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as prismicActions from "../redux/actions/prismicActions";
import { storeAgeGate } from "../redux/actions/gtmActions";
import "es6-promise/auto";
import {
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
// import Modal from 'react-modal';
import LocaleSwitch from "../components/LocaleSwitch";
import htmlSerializer from '../plugins/htmlSerializer';
import axios from 'axios';
import { Link } from 'react-router-dom'

// let userLat;
// let userLong;
// let userCountry;
// let userProvince;
// let getLatLongString;
let getLocationString;
let currentCountryCanada = false;

class AgeGate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      doc: null,
      currentLang: "EN",
      disabled: true,
      modal: true,
      modalTitle: "Please verify your age before entering",
      modalTitleOther: "Veuillez vérifier votre âge avant d'entrer",
      yearInputValue: "",
      monthInputValue: "",
      dayInputValue: "",
      legalAge: "19",
      provOptionsState: { value: "Province", error: false },
      provDropdownOpen: false,
      yearValidationMessage: "Please enter valid year",
      monthValidationMessage: "Please enter valid month",
      dayValidationMessage: "Please enter valid day",
      yearLabelText: "Year",
      monthLabelText: "Month",
      dayLabelText: "Day",
      underAgeMessage: "",
      formSubmittedMessage: "",
      modalLogoPath: "",
      submitBtnText: "Submit",
      submitBtnTextOther: "Soumettre",
      submitBtnTextCurrent: "",
      cookiePresent: false,
      disableProvinceDropdown: false,
      disableLanguageToggle: false,
      otherLanguageAbbreviation: "FR",
      yearPlaceholderTextOther: "AAAA",
      monthPlaceholderTextOther: "MM",
      dayPlaceholderTextOther: "JJ",
      currentModalTitle: "Please verify your age before entering",
      checkboxLabel: "Remember me for 30 days",
      // checkboxValue: false,
      rememberCheckbox: false,
      uaHeader1: "",
      uaHeader2: "",
      uaHeader3: "",
      uaHeader4: "",
      randomCopy: "",
      goBackText: "",
      // Johns stuff
      province: "Province",
      day: "",
      month: "",
      year: "",
      provinceAlert: "",
      yearAlert: "",
      monthAlert: "",
      dayAlert: "",
    };
    this.toggle = this.toggle.bind(this);
    this.limitStringLength = this.limitStringLength.bind(this);
    this.calculateAge = this.calculateAge.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.goBack = this.goBack.bind(this);
  }

  componentWillMount() {
    const lsObj = JSON.parse(localStorage.getItem('altavie_agegate'));
    const seObj = JSON.parse(sessionStorage.getItem('altavie_agegate'));
    if((lsObj && Date.now() < lsObj.expiresAt) || seObj){
      this.props.history.push('/');
      // const locale = localStorage.getItem('localeAltaVie');
      // if(locale === 'en-ca')
      //   window.location.href = "https://mailchi.mp/c9a75ae47a61/altavie"
      // else
      //   window.location.href = "https://mailchi.mp/a57e421e25ec/altavie-fr"
      }
    this.findAgeGate(this.props);
  }

  componentWillReceiveProps(props) {
    this.findAgeGate(props);
  }
  componentDidMount() {
    if (this.props.disableLanguageToggle === true) {
      this.setState({
        disableLanguageToggle: this.props.disableLanguageToggle
      });
    }
    if (this.props.disableProvinceDropdown === true) {
      this.setState({
        disableProvinceDropdown: this.props.disableProvinceDropdown
      });
    }
    if (this.props.cookiePresent === true) {
      this.setState({ cookiePresent: true });
    }
    // if (this.readCookie("auroracookie")) {
    //   this.setState({ cookiePresent: true });
    //   this.setState({ modal: false });
    // }
    if (this.props.yearPlaceholderTextOther) {
      this.setState({
        yearPlaceholderTextOther: this.props.yearPlaceholderTextOther
      });
    }
    if (this.props.monthPlaceholderTextOther) {
      this.setState({
        monthPlaceholderTextOther: this.props.monthPlaceholderTextOther
      });
    }
    if (this.props.dayPlaceholderTextOther) {
      this.setState({
        dayPlaceholderTextOther: this.props.dayPlaceholderTextOther
      });
    }
    if (this.props.submitBtnTextOther) {
      this.setState({ submitBtnTextOther: this.props.submitBtnTextOther });
    }
    if (this.props.submitBtnText) {
      this.setState({ submitBtnText: this.props.submitBtnText });
      this.setState({ submitBtnTextCurrent: this.props.submitBtnText });
    } else if (!this.props.submitBtnText) {
      this.setState({ submitBtnTextCurrent: this.state.submitBtnText });
    }

    if (this.props.otherLanguageAbbreviation) {
      this.setState({
        otherLanguageAbbreviation: this.props.otherLanguageAbbreviation
      });
    }

    if (this.props.modalLogoPath) {
      this.setState({ modalLogoPath: this.props.modalLogoPath });
    }
    if (this.props.modalTitleOther) {
      this.setState({ modalTitleOther: this.props.modalTitleOther });
    }

    if (this.props.modalTitle) {
      this.setState({ modalTitle: this.props.modalTitle });
      this.setState({ currentModalTitle: this.props.modalTitle });
    }

    if (this.props.legalAge) {
      this.setState({ legalAge: this.props.legalAge });
    }

    if (this.props.currentLang === this.state.otherLanguageAbbreviation) {
      this.setState({ currentLang: this.props.currentLang });
    }

    if (this.props.locale === 'fr-ca') {
      this.setState({ currentLang: 'fr-ca' });
    }

    if (this.props.locale === 'en-ca') {
      this.setState({ currentLang: 'en-ca' });
    }
  }

  findAgeGate(props) {
    const _this = this;
    if (props.prismicData) {
      let doc;
      if (props.prismicData.results.length > 0) {
        let doc = props.prismicData.results.find(
          result => result.type === "age_gate"
        );
        this.setState({
          doc
        }
        , () => {
          var underageSection = this.state.doc.data.body.find(result => result.slice_type === "underage_section" );
          this.setState({
             uaHeader1: PrismicReact.RichText.render(underageSection.primary.header, this.props.linkResolver),
            //  uaHeader2: underageSection.primary.sub_header_1[0].text,
            //  uaHeader3: underageSection.primary.sub_header_2[0].text,
            //  uaHeader4: underageSection.primary.sub_header_4[0].text,
             randomCopy: PrismicReact.RichText.render(underageSection.primary.random_copy),
             goBackText: underageSection.primary.back_text
          });
          if (doc.data.locations) {
            doc.data.locations.forEach(function(element) {
              if (element.location.toLowerCase().includes("alberta")) {
                _this.setState({
                  abText: element.location
                });
              }
              if (element.location.toLowerCase().includes("col")) {
                _this.setState({
                  bcText: element.location
                });
              }
              if (element.location.toLowerCase().includes("manit")) {
                _this.setState({
                  mbText: element.location
                });
              }
              if (element.location.toLowerCase().includes("brunswick")) {
                _this.setState({
                  nbText: element.location
                });
              }
              if (
                element.location.toLowerCase().includes("nouvelle") ||
                element.location.toLowerCase().includes("nova")
              ) {
                _this.setState({
                  nsText: element.location
                });
              }
              if (
                element.location.toLowerCase().includes("newfoundland") ||
                element.location.toLowerCase().includes("labrador")
              ) {
                _this.setState({
                  nlText: element.location
                });
              }
              if (element.location.toLowerCase().includes("territ")) {
                _this.setState({
                  ntText: element.location
                });
              }
              if (element.location.toLowerCase().includes("nunavut")) {
                _this.setState({
                  nuText: element.location
                });
              }
              if (element.location.toLowerCase().includes("ontario")) {
                _this.setState({
                  ontText: element.location
                });
              }
              if (element.location.toLowerCase().includes("sask")) {
                _this.setState({
                  skText: element.location
                });
              }
              if (element.location.toLowerCase().includes("yukon")) {
                _this.setState({
                  ykText: element.location
                });
              }
              if (element.location.toLowerCase().includes("qu")) {
                _this.setState({
                  qcText: element.location
                });
              }
            });
          }

          if (doc.data.day) {
            _this.setState({
              dayPlaceholderText: doc.data.day
            });
          }

          if (doc.data.year) {
            _this.setState({
              yearPlaceholderText: doc.data.year
            });
          }

          if (doc.data.enter_button_text) {
            _this.setState({
              submitBtnTextCurrent: doc.data.enter_button_text
            });
          }

          if (doc.data.checkbox_blurb[0].text) {
            _this.setState({
              checkboxLabel: doc.data.checkbox_blurb[0].text
            });
          }

          //  this.getLatLong();

        });
      }
    }
  }

  limitStringLength(e) {
    const targetValue = e.target.value;
    const stringLength = targetValue.length + 1;
    let maxLength;
    let trimmedString;

    if (e.target.id === "yearField") {
      maxLength = "4";
      trimmedString = targetValue.substr(0, maxLength);
      this.setState({ yearInputValue: trimmedString });
    }
    if (e.target.id === "monthField") {
      maxLength = "2";
      trimmedString = targetValue.substr(0, maxLength);
      this.setState({ monthInputValue: trimmedString });
    }
    if (e.target.id === "dayField") {
      maxLength = "2";
      trimmedString = targetValue.substr(0, maxLength);
      this.setState({ dayInputValue: trimmedString });
    }
  }

  toggle() {
    this.setState({
      modal: !this.state.modal
    });
  }

  // createCookie(name, value, days) {
  //   if (days) {
  //     var date = new Date();
  //     date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  //     var expires = "; expires=" + date.toGMTString();
  //   } else var expires = "";
  //   document.cookie = name + "=" + value + expires + "; path=/";
  // }

  // readCookie(name) {
  //   var nameEQ = name + "=";
  //   var ca = document.cookie.split(";");
  //   for (var i = 0; i < ca.length; i++) {
  //     var c = ca[i];
  //     while (c.charAt(0) == " ") c = c.substring(1, c.length);
  //     if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  //   }
  //   return null;
  // }

  validateProvince(province) {
    if (province === "Province" || province === "" || !province) {
      this.setState({
        provinceAlert: "alert-error"
      });
    } else {
      this.setState({
        provinceAlert: ""
      });
      return true;
    }
  }

  validateYear(year) {
    const currentYear = new Date().getFullYear()
    if (!year || year === "" || year < (currentYear - 130) || year > currentYear) {
      this.setState({
        yearAlert: "alert-error"
      });
    } else {
      this.setState({
        yearAlert: ""
      });
      return true;
    }
  }

  validateMonth(month) {
    if (!month || month === "" || month < 0 || month > 12) {
      this.setState({
        monthAlert: "alert-error"
      });
    } else {
      this.setState({
        monthAlert: ""
      });
      return true;
    }
  }

  validateDay(day) {
    if (!day || day === "" || day < 0 || day > 31) {
      this.setState({
        dayAlert: "alert-error"
      });
    } else {
      this.setState({
        dayAlert: ""
      });
      return true;
    }
  }

  validateFields(province, year, month, day) {
    var validProvince = this.validateProvince(province);
    var validYear = this.validateYear(year);
    var validMonth = this.validateMonth(month);
    var validDay = this.validateDay(day);

    if (validProvince && validYear && validMonth && validDay) {
      return true;
    }
  }

  validateAge(userAge, legalAge, numberOfDaysToRetainCookie) {
    if (userAge >= legalAge) {
      // User has confirmed legal age
      window.ageGate === false;
      if(numberOfDaysToRetainCookie) {
        let remainCookieDays = numberOfDaysToRetainCookie;
        localStorage.setItem('altavie_agegate', JSON.stringify({'value': true, 'expiresAt': Date.now() + 86400000 * remainCookieDays}));

        this.props.storeAgeGate(localStorage.getItem('altavie_agegate'))
      } else {
        sessionStorage.setItem('altavie_agegate', JSON.stringify({'value': true}))
      }
      // if(this.state.doc.lang === 'en-ca')
      //   window.location.href = "https://mailchi.mp/c9a75ae47a61/altavie"
      // else
      //   window.location.href = "https://mailchi.mp/a57e421e25ec/altavie-fr"
      // this.setState({ modal: false });
      const { from } = this.props.location.state || { from: { pathname: "/"} };
      // if(numberOfDaysToRetainCookie) {
      //   let remainCookieDays = numberOfDaysToRetainCookie;
      //   localStorage.setItem('altavie_agegate', JSON.stringify({'value': true, 'expiresAt': Date.now() + 86400000 * remainCookieDays}));
      // } else {
      //   sessionStorage.setItem('altavie_agegate', JSON.stringify({'value': true}))
      // }
      window.location.href = from.pathname;
      // this.props.history.push({pathname: from.pathname, search: from.search});
    //   this.createCookie("auroracookie", "agecookie", numberOfDaysToRetainCookie);
    } else {
      var calculateDaysBetweenDates = (firstDate, secondDate) => {
        var oneDay = 24 * 60 * 60 * 1000; 
        return Math.round(
          Math.abs((firstDate.getTime() - secondDate.getTime()) / oneDay)
        );
      }

      var yearsUntilLegal = legalAge - userAge;

      const birthDate = new Date(
        parseInt(this.state.year),
        parseInt(this.state.month) - 1,
        parseInt(this.state.day)
      );
      const legalDate = new Date(
        parseInt(this.state.year) + parseInt(legalAge),
        parseInt(this.state.month) - 1,
        parseInt(this.state.day)
      );
      const currentDate = new Date();
      const daysUntilLegal = calculateDaysBetweenDates(
        currentDate,
        legalDate
      );

      if (this.state.underAgeMessage === "") {
        this.setState({
        formSubmittedMessage: daysUntilLegal
        });
      } else {
        this.setState({ formSubmittedMessage: this.state.underAgeMessage });
      }
    }
  }

  calculateAge(birth_month, birth_day, birth_year) {
    var today_date = new Date();
    var today_year = today_date.getFullYear();
    var today_month = today_date.getMonth();
    var today_day = today_date.getDate();
    var age = today_year - birth_year;

    if (birth_year.indexOf("<") >= 0) {
      age = 100;
    } else {
      if (today_month < birth_month - 1) {
        age--;
      }
      if (birth_month - 1 == today_month && today_day < birth_day) {
        age--;
      }
    }

    return age;
  }

  // Johns stuff
  handleChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    const _this = this
    
    // const validFields = this.validateFields(this.state.province, this.state.year, this.state.month, this.state.day);

    this.setState({
      [name]: value
    });

    target.classList.forEach(function(item){
      if (item.includes('select')) {
        _this.setState({ province: value });
        _this.validateProvince(value);
        return false;
      }
      if (item.includes('year')) {
        _this.setState({ year: value });
        _this.validateYear(value);
        return false;
      }
      if (item.includes('month')) {
        _this.setState({ month: value });
        _this.validateMonth(value);
        return false;
      }
      if (item.includes('day')) {
        _this.setState({ day: value });
        _this.validateDay(value);
        return false;
      }
    });
    // if(validFields) {
    //   this.setState({disabled: false})
    // } else {
    //   this.setState({disabled: true})
    // }
  }

  // getLatLong() {
  //   const apiKey = 'AIzaSyC3pBzx896sYQK0BVClnxMQfSw43-TUCJc';
  //   getLatLongString = 'https://www.googleapis.com/geolocation/v1/geolocate?key=' + apiKey;
  //   axios.post(getLatLongString).then((response) => {
  //       if (response.data.location) {
  //           if (response.data.location.lat) {
  //               userLat = response.data.location.lat;
  //           }

  //           if (response.data.location.lng) {
  //               userLong = response.data.location.lng;
  //           }
  //           if (userLat && userLong) {
  //               getLocationString = 'https://maps.googleapis.com/maps/api/geocode/json?latlng=' + userLat + ',' + userLong + '&key=' + apiKey;
  //               this.getCountry();
  //           }
  //       }
  //   });
  // }

  getCountry() {
    let locationResult;
    
    axios.post(getLocationString).then((response) => {
        const _this = this;
        if (response) {
            locationResult = response.data.results;

            locationResult.forEach(function(element, index) {
                if (element.types.includes('administrative_area_level_2')) {
                    if (element.address_components.length === 3 && element.address_components[2] !== undefined) {
                        if (element.address_components[2].long_name !== undefined) {
                            if (element.address_components[2].long_name === 'Canada') {
                                currentCountryCanada = true;

                                if (currentCountryCanada === true) {
                                    _this.getProvince();
                                }


                                if (currentCountryCanada === false) {
                                    _this.getProvince();
                                    _this.setState({ disableProvinceDropdown: true });
                                }
                            }
                        }
                    }
                }
            });
        }
    }).catch(function(error) {
        return false;
    });
  }

  getProvince() {
    let locationResult;
    const ageGateData = this.props.prismicData.results.find(
      result => result.type === "age_gate"
    );
    const provincesArray = ageGateData.data.locations;
    axios.post(getLocationString).then((response) => {
        const _this = this;
        if (response) {
            locationResult = response.data.results;
            locationResult.forEach(function(element, index) {
                if (element.types.includes('administrative_area_level_1')) {
                    element.address_components.forEach(function(element, index) {
                      if (provincesArray.indexOf(element.long_name) < 0) {
                        _this.setProvince(element.long_name);
                      }
                    });
                }
            });
        }
    }).catch(function(error) {
        return false;
    });
  }

  setProvince(prov) {
    if (prov === 'Alberta' || prov === 'Manitoba' || prov === 'Nunavut' || prov === 'Ontario' || prov === 'Saskatchewan' || prov === 'Yukon') {
      this.setState({ province: prov });
    }

    if (prov === 'British Columbia') {
      if (this.props.prismicData.results[0].lang === 'en-ca') {
        this.setState({ province: prov });
      } else {
        this.setState({ province: 'Colombie-Britannique' });
      }
    }

    if (prov === 'New Brunswick') {
      if (this.props.prismicData.results[0].lang === 'en-ca') {
        this.setState({ province: prov });
      } else {
        this.setState({ province: 'Nouveau-Brunswick' });
      }
    }

    if (prov.includes('Newsfoundland')) {
      if (this.props.prismicData.results[0].lang === 'en-ca') {
        this.setState({ province: prov });
      } else {
        this.setState({ province: 'Terre-Neuve-et-Labrador' });
      }
    }

    if (prov.includes('Newsfoundland')) {
      if (this.props.prismicData.results[0].lang === 'en-ca') {
        this.setState({ province: prov });
      } else {
        this.setState({ province: 'Terre-Neuve-et-Labrador' });
      }
    }

    if (prov.includes('Northwest')) {
      if (this.props.prismicData.results[0].lang === 'en-ca') {
        this.setState({ province: prov });
      } else {
        this.setState({ province: 'Territoires du Nord-Ouest' });
      }
    }

    if (prov.includes('Northwest')) {
      if (this.props.prismicData.results[0].lang === 'en-ca') {
        this.setState({ province: prov });
      } else {
        this.setState({ province: 'Territoires du Nord-Ouest' });
      }
    }

    if (prov.includes('Nova')) {
      if (this.props.prismicData.results[0].lang === 'en-ca') {
        this.setState({ province: prov });
      } else {
        this.setState({ province: 'Nouvelle-Écosse' });
      }
    }

    if (prov.includes('Nova')) {
      if (this.props.prismicData.results[0].lang === 'en-ca') {
        this.setState({ province: prov });
      } else {
        this.setState({ province: 'Nouvelle-Écosse' });
      }
    }

    if (prov.includes('Prince')) {
      if (this.props.prismicData.results[0].lang === 'en-ca') {
        this.setState({ province: prov });
      } else {
        this.setState({ province: 'Île-du-Prince-Édouard' });
      }
    }

    if (prov.includes('Quebec')) {
      if (this.props.prismicData.results[0].lang === 'en-ca') {
        this.setState({ province: prov });
      } else {
        this.setState({ province: 'Québec' });
      }
    }

    if (prov.includes('Quebec')) {
      if (this.props.prismicData.results[0].lang === 'en-ca') {
        this.setState({ province: prov });
      } else {
        this.setState({ province: 'Québec' });
      }
    }
  }

  handleSubmit(event) {
    event.preventDefault();
    const validFields = this.validateFields(this.state.province, this.state.year, this.state.month, this.state.day);
    let legalAge = this.state.legalAge;
    let numberOfDaysToRetainCookie = 0;
    if (validFields) {
      // All fields are valid, check if age is valid
      let userAge = this.calculateAge(this.state.month, this.state.day, this.state.year);
      if (this.state.rememberCheckbox === true) {
        numberOfDaysToRetainCookie = 30;
      }
      if (this.state.province === 'Alberta' || this.state.province === 'Manitoba' || this.state.province === 'Northwest Territories' || this.state.province === 'Nunavut' || this.state.province === 'Quebec' || this.state.province === 'Saskatchewan' || this.state.province === 'Yukon' || this.state.province === 'Territoires du Nord-Ouest') {
        this.setState({ legalAge: 18 });
        legalAge = 18;
      }
      this.validateAge(userAge, legalAge, numberOfDaysToRetainCookie);
    }
  }

  goBack(){
    window.history.back();
  }

  render() {
    if (this.state.doc) {
      let {
        prismicCtx
      } = this.props
      document.querySelector('html').classList.add('ready');
      const otherLanguageAbbreviation = this.state.otherLanguageAbbreviation;
      var docData = this.state.doc.data;
      let header = PrismicReact.RichText.render(docData.header, prismicCtx.linkResolver, htmlSerializer);
      let logoPath = docData.logo.url;
      let blurb = PrismicReact.RichText.render(docData.blurb, prismicCtx.linkResolver, htmlSerializer);
      let yearPlaceholder = docData.year;
      let monthPlaceholder = docData.month;
      let dayPlaceholder = docData.day;
      let cta = docData.enter_button_text;
      let selectOptions = docData.locations.map((location, index) => {
        return(
          <option key={index} value={location.location}>
            {location.location}
          </option>
        );
          });
      const dateLabel = docData.date_label;
      const provinceLabel = docData.province_label;
      const provinceValidationMessage = docData.province_validation_message;
      const dayValidationMessage = docData.day_validation_message;
      const monthValidationMessage = docData.month_validation_message;
      const yearValidationMessage = docData.year_validation_message;
      const disclaimerMessage = PrismicReact.RichText.render(docData.disclaimer, prismicCtx.linkResolver, htmlSerializer);
      // const backgroundImageSrc = docData.background_image.url;
      // const backgroundImageStyle = 'url(' + backgroundImageSrc + ')';
      let modalBg;

      setTimeout(function(){ 
        modalBg = document.querySelectorAll('.ReactModal__Overlay');
        if (modalBg.length > 0) {
          modalBg[0].classList.add("age-gate-background");
        }
      }, 1);      

      if (this.state.cookiePresent === false) {
        window.ageGate = true;

        return (
          <div className="age-gate age-gate-background">
              <div className="age-gate-background">
                <div className="age-gate-component">
                  <div className="language-toggle-container">
                    <LocaleSwitch />
                  </div>
                  <div className="container">
                    <img src={logoPath} alt="MedReleaf San Rafael" className="modal-logo-img" />
                    {this.state.formSubmittedMessage.length != "" ? (
                      <div className="form-submit-error">
                        <div className="h3 center age-gate-legal">
                          <div className="underage-heading">
                            {this.state.uaHeader1}
                          </div>
                          
                          <div className="age-gate-inline">
                            {this.state.randomCopy}
                            {/* <p>{this.state.uaHeader2} <strong>{this.state.formSubmittedMessage}</strong> {this.state.uaHeader3} {this.state.uaHeader4}</p> */}
                          </div>
                          {this.state.goBackText ? <button className="btn back-btn" onClick={this.goBack}>{this.state.goBackText}</button> : ""}
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                    {this.state.formSubmittedMessage.length < 1 ? (
                      <Form
                        id="age-gate-form"
                        className="age-gate-form"
                        onSubmit={this.handleSubmit}
                        noValidate
                      >
                        <ModalHeader
                          className="age-gate-overlay-header"
                          toggle={this.toggle}
                        >
                          {header}
                          {blurb}
                        </ModalHeader>
                        <ModalBody>
                          <div className="age-gate-inputs">
                            <div className="date-fields-container">
                              <Label className="dates-label">{dateLabel}</Label>
                              <div className="flexbox">
                                <FormGroup>
                                  <Label for="yearField" hidden>{this.state.yearLabelText}</Label>
                                  <Input
                                    type="number"
                                    name="year"
                                    id="yearField"
                                    className="year-input input-field"
                                    placeholder={yearPlaceholder}
                                    onChange={this.handleChange}
                                    value={this.state.year}
                                    maxLength={4}
                                    min={1900}
                                    required
                                  />
                                  <div className={`validation-message ${this.state.yearAlert}`}>
                                    {yearValidationMessage}
                                  </div>
                                </FormGroup>
                                <FormGroup>
                                  <Label for="monthField" hidden>
                                    {this.state.monthLabelText}
                                  </Label>
                                  <Input
                                    type="number"
                                    name="month"
                                    id="monthField"
                                    className="month-input input-field"
                                    placeholder={monthPlaceholder}
                                    onChange={this.handleChange}
                                    value={this.state.month}
                                    maxLength={2}
                                    min={1}
                                    max={12}
                                    validate={{ max: { value: 12 }, min: { value: 1 } }}
                                    required
                                  />
                                  <div className={`validation-message ${this.state.monthAlert}`}>
                                    {monthValidationMessage}
                                  </div>
                                </FormGroup>
                                <FormGroup>
                                  <Label for="dayField" hidden>{this.state.dayLabelText}</Label>
                                  <Input
                                    type="number"
                                    name="day"
                                    id="dayField"
                                    className="day-input input-field"
                                    placeholder={dayPlaceholder}
                                    onChange={this.handleChange}
                                    value={this.state.day}
                                    maxLength={2}
                                    min={1}
                                    max={31}
                                    validate={{ max: { value: 31 }, min: { value: 1 } }}
                                    required
                                  />
                                  <div className={`validation-message ${this.state.dayAlert}`}>
                                    {dayValidationMessage}
                                  </div>
                                </FormGroup>
                              </div>
                            </div>
                            <FormGroup className="province-group">
                              <Label htmlFor="provinceSelect" className="province-label">{provinceLabel}</Label>
                              <div className="custom-select-wrapper">
                                <Input className="custom-select" type="select" name="province" id="exampleSelect" value={this.state.province} onChange={this.handleChange}>
                                  <option value="" defaultValue>Province</option>
                                  {selectOptions}
                                </Input>
                              </div>
                              <div className={`validation-message ${this.state.provinceAlert}`}>
                                {provinceValidationMessage}
                              </div>
                            </FormGroup>
                          </div>
                          <div className="disclaimer">
                            {disclaimerMessage}
                          </div>
                          {/* <FormGroup className="checkbox-group">
                            <div className="custom-checkbox">
                              <Input
                              type="checkbox"
                              name="rememberCheckbox"
                              id="rememberField"
                              onChange={this.handleChange}
                              className="checkbox-input" />
                              <label htmlFor="rememberField">{this.state.checkboxLabel}</label>
                            </div>
                          </FormGroup> */}
                        </ModalBody>
                        <ModalFooter>
                          <Button
                            type="submit"
                            form="age-gate-form"
                            value={this.state.submitBtnTextCurrent}
                            // disabled={this.state.disabled}
                          >
                            {cta}
                          </Button>
                        </ModalFooter>
                      </Form>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
          </div>
        );
      } else {
        window.ageGate = false;
        return null;
      }
    } else {
      return null;
    }
  }
}
const mapStateToProps = state => ({
  locale: state.global.locale,
  prismicCtx: state.prismic.prismicCtx,
  prismicData: state.prismic.prismicData
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ 
    getActiveDoc: prismicActions.getActiveDoc,
    storeAgeGate: storeAgeGate
  }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(AgeGate);



// WEBPACK FOOTER //
// ./src/pages/AgeGate.js